import http from "@services/httpService"
import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import type {
  ICompanyPrintTemplate,
  ICompanyPrintTemplateUpload,
  CompanyPrintTemplateTypeValue,
} from "@models/master-data/companyPrintTemplateModel"

class CompanyPrintTemplateService {
  /** UPSERT theo (companyId, type): chưa có ⇒ insert, đã có ⇒ ghi đè content. */
  public async upload(
    body: ICompanyPrintTemplateUpload
  ): Promise<ICompanyPrintTemplate> {
    const res = await http.post(
      "api/services/app/CompanyPrintTemplate/Upload",
      body
    )
    notifySuccess(LNotification("SUCCESS"), LNotification("SAVING_SUCCESSFULLY"))
    return res.data.result
  }

  /** Trả undefined khi công ty chưa có mẫu loại đó (BE trả result = null, HTTP 200). */
  public async getByType(
    companyId: number,
    type: CompanyPrintTemplateTypeValue
  ): Promise<ICompanyPrintTemplate | undefined> {
    const res = await http.get(
      "api/services/app/CompanyPrintTemplate/GetByType",
      { params: { companyId, type } }
    )
    return res.data.result ?? undefined
  }

  /** ⚠️ Param BE là `id` (EntityDto<int>), KHÔNG phải `companyId`. */
  public async getListByCompany(
    companyId: number
  ): Promise<ICompanyPrintTemplate[]> {
    const res = await http.get(
      "api/services/app/CompanyPrintTemplate/GetListByCompany",
      { params: { id: companyId } }
    )
    return res.data.result ?? []
  }
}

export default new CompanyPrintTemplateService()
